import { Component } from '@angular/core';
import { FireflyDrawerContent } from '@capital-access/firefly/components';

// TODO: should be removed when appropriate components will be created
@Component({
  template: '',
  standalone: false
})
export class EmptyDrawerContentComponent extends FireflyDrawerContent<unknown> {}
